var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyAnswerWAttributionsAction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10358_86491",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10358_86491)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41859 15.5822C1.69766 15.8612 2.03312 16.0008 2.425 16.0008H11.45V14.5758H2.425V3.65078H1V14.5758C1 14.9677 1.13953 15.3031 1.41859 15.5822ZM4.26859 12.7322C4.54766 13.0113 4.88312 13.1508 5.275 13.1508H12.875C13.2669 13.1508 13.6023 13.0113 13.8814 12.7322C14.1605 12.4531 14.3 12.1177 14.3 11.7258V10.4509H12.875V11.7258H5.275V2.22578H12.875V2.85089H14.3V2.22578C14.3 1.83391 14.1605 1.49844 13.8814 1.21938C13.6023 0.940313 13.2669 0.800781 12.875 0.800781H5.275C4.88312 0.800781 4.54766 0.940313 4.26859 1.21938C3.98953 1.49844 3.85 1.83391 3.85 2.22578V11.7258C3.85 12.1177 3.98953 12.4531 4.26859 12.7322Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5327 3.6875V7.08359C10.5327 7.85 10.2726 8.44766 9.75225 8.87656C9.23193 9.29844 8.49014 9.55859 7.52686 9.65703V8.00117C8.08936 7.92383 8.52178 7.77969 8.82412 7.56875C9.12646 7.35781 9.32686 7.0625 9.42529 6.68281H7.52686V3.6875H10.5327ZM14.4351 3.6875V7.08359C14.4351 7.85 14.1749 8.44766 13.6546 8.87656C13.1343 9.29844 12.3925 9.55859 11.4292 9.65703V8.00117C11.9917 7.92383 12.4241 7.77969 12.7265 7.56875C13.0288 7.35781 13.2292 7.0625 13.3276 6.68281H11.4292V3.6875H14.4351Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAnswerWAttributionsAction);
export default __webpack_public_path__ + "static/media/copy-answer-w-attributions-action.dafb1e9b57f2f8b2ac0049fe6cbed4eb.svg";
export { ForwardRef as ReactComponent };